// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PtoControlSquareOutlinedSvg from "@fishx/icons-svg/es/asn/PtoControlSquareOutlined";
import FishxIcon from '../components/FishxIcon';

var PtoControlSquareOutlined = function PtoControlSquareOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PtoControlSquareOutlinedSvg
  }));
};

PtoControlSquareOutlined.displayName = 'PtoControlSquareOutlined';
export default React.forwardRef(PtoControlSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PtoControlSquareOutlined.js
// module id = 3900
// module chunks = 0